import React from "react";
import { Outlet } from "react-router";

import { FeatureFlags, useFlags } from "merchant-portal-frontend/src/feature-flags";
import { GrantScope } from "merchant-portal-frontend/src/global.constants";
import { useAuth } from "merchant-portal-frontend/src/providers/AuthProvider";
import {
	MerchantProgramEnrollment,
	useMerchantPrograms,
} from "merchant-portal-frontend/src/providers/MerchantProgramsProvider";
import LoadingPage from "merchant-portal-pages/LandingPage/LoadingPage";
import PermissionDenied from "merchant-portal-pages/LandingPage/PermissionDenied/PermissionDenied";

export interface AuthorizedRouteProps {
	requiredScope?: GrantScope;
	requiredProgramEnrollment?: MerchantProgramEnrollment;
	requiredFeatureFlag?: keyof FeatureFlags;
	additionalRequirements?: boolean;
}

export const AuthorizedRoute = ({
	requiredScope,
	requiredProgramEnrollment,
	requiredFeatureFlag,
	additionalRequirements,
}: AuthorizedRouteProps) => {
	const flags = useFlags();
	const { hasGrantAccess } = useAuth();
	const { isFetchingMerchantPrograms, hasProgramEnrollment } = useMerchantPrograms();

	if (requiredScope && !hasGrantAccess(requiredScope)) {
		return <PermissionDenied />;
	}

	if (isFetchingMerchantPrograms) {
		return <LoadingPage />;
	}

	if (requiredProgramEnrollment && !hasProgramEnrollment(requiredProgramEnrollment)) {
		return <PermissionDenied />;
	}

	if (requiredFeatureFlag && flags?.[requiredFeatureFlag] === false) {
		return <PermissionDenied />;
	}

	if (additionalRequirements !== undefined && !additionalRequirements) {
		return <PermissionDenied />;
	}

	return <Outlet />;
};
